import { Routes } from '@angular/router';
import { AboutPage } from './pages/about/about-page.component';
import { HomePage } from './pages/home/home-page.component';

export const routes: Routes = [
    {
        path: '',
        component: HomePage,
        title: 'Home Page',
        data: { hideFooterOnDesktop: true },
    },
    {
        path: 'about',
        component: AboutPage,
        title: 'About Page',
    },
];
